<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="main-container" *ngIf="projectLoaded | async">
    <div class="container">
        <div class="row d-none d-md-block">
            <button (click)="location.back()" class="btn btn-link btn-back">
                <em class="icon-arrow-right1"></em>
                <span class="d-inline">{{ 'components.button.back' | translate }}</span>
            </button>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <h1 class="primary-1 fw-b h3 project-name">{{ project.name }}</h1>
            </div>
            <div class="col-12 mt-2">
                <div class="project-header box-shadow">
                    <div class="project-header__photo">
                        <img src="{{ project.pictureAccessLink }}" alt="" />
                    </div>

                    <div class="project-header__join">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col">
                                    <div class="fw-b project-owner-title">
                                        {{ 'projects.pages.details.projectInitiator' | translate }}
                                    </div>
                                    <div *ngIf="!project.isAnonymized" class="profileOwner">
                                        <a
                                            [routerLink]="['/directory/profile', projectOwner.id]"
                                            routerLinkActive="active"
                                            target="_blank"
                                            class="d-flex align-items-center text-decoration-none"
                                        >
                                            <div class="text-white text-decoration-none">
                                                <span> {{ projectOwner.fullName }} </span>
                                            </div>
                                        </a>
                                    </div>
                                    <div *ngIf="project.isAnonymized">
                                        {{ 'projects.pages.details.isAnonymous' | translate }}
                                    </div>
                                </div>
                                <div class="col-auto join-btn ml-auto" *ngIf="project.status === 'finished'; else activeProjectDisplay">
                                    {{ 'projects.pages.details.terminatedProjectDate' | translate : { date: project.closingDate } }}

                                    <transparent-action-button
                                        *ngIf="isOwner || isPlatformAdmin"
                                        icon="pi pi-trash"
                                        [tooltip]="'projects.pages.details.deleteProject' | translate"
                                        (click)="openDeleteProjectDialog()"
                                    >
                                    </transparent-action-button>
                                </div>

                                <ng-template #activeProjectDisplay>
                                    <div class="col-auto">
                                        <div class="actions-buttons">
                                            <transparent-action-button
                                                *ngIf="project.isPublic"
                                                icon="pi pi-copy"
                                                tooltip="Copier le lien du projet"
                                                (click)="copyProjectUrl()"
                                            >
                                            </transparent-action-button>
                                            <transparent-action-button
                                                *ngIf="isAModifier !== modifierTypes.None || isOwner"
                                                icon="pi pi-pencil"
                                                [tooltip]="'components.button.modify' | translate"
                                                (click)="modifyProject()"
                                            >
                                            </transparent-action-button>
                                            <transparent-action-button
                                                *ngIf="project.status === 'published' && (isOwner || isPlatformAdmin)"
                                                icon="pi pi-stop"
                                                [tooltip]="'projects.pages.details.close.title' | translate"
                                                (click)="openCloseProjectModal()"
                                            >
                                            </transparent-action-button>
                                            <transparent-action-button
                                                *ngIf="isOwner || isPlatformAdmin"
                                                icon="pi pi-trash"
                                                [tooltip]="'projects.pages.details.deleteProject' | translate"
                                                (click)="openDeleteProjectDialog()"
                                            >
                                            </transparent-action-button>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body project-header-card box-shadow">
                    <div class="row">
                        <div class="col-sm col-12">
                            <div class="fw-b primary-1">
                                {{ 'projects.pages.details.projectType' | translate }}
                            </div>
                            <div>{{ project.projectType.label | wtranslate : 'projectTypes' }}</div>
                        </div>
                        <div class="col-sm col-12">
                            <div class="fw-b primary-1">
                                {{ 'projects.pages.details.expectedStartDate' | translate }}
                            </div>
                            <div>{{ project.startDate }}</div>
                        </div>
                        <div class="col-sm col-12">
                            <div class="fw-b primary-1">
                                {{ 'projects.pages.details.expectedEndDate' | translate }}
                            </div>
                            <div>{{ project.endDate }}</div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <!-- Visiblité -->
                        <div class="col-12 col-md-4 col-sm-6">
                            <div class="row">
                                <div class="col-12 fw-b primary-1">
                                    {{ 'projects.pages.details.visibility' | translate }}
                                </div>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col col-sm-6 fw-b primary-1">
                                            {{ 'projects.pages.details.anonymous.title' | translate }}
                                        </div>
                                        <div class="col primary-1" *ngIf="project.isAnonymous">
                                            {{ 'projects.pages.details.anonymous.enabled' | translate }}
                                            <em
                                                class="icon-info"
                                                [pTooltip]="'projects.pages.details.anonymous.enabledTooltip' | translate"
                                                tooltipStyleClass="custom-primeng-tooltip"
                                            ></em>
                                        </div>
                                        <div class="col primary-1" *ngIf="!project.isAnonymous">
                                            {{ 'projects.pages.details.anonymous.disabled' | translate }}
                                            <em
                                                class="icon-info"
                                                [pTooltip]="'projects.pages.details.anonymous.disabledTooltip' | translate"
                                                tooltipStyleClass="custom-primeng-tooltip"
                                            ></em>
                                        </div>
                                    </div>
                                </div>
                                <!-- organisation -->
                                <div class="col-12">
                                    <div class="row" *ngIf="(project.organization && !project.allCommunitiesVisibility) || project.isAnonymized">
                                        <div class="col col-sm-6 fw-b primary-1">
                                            {{ 'projects.pages.details.organizationTitle' | translate }}
                                        </div>
                                        <div class="col col-sm primary-1" *ngIf="project.isAnonymized">
                                            {{ 'projects.pages.details.isAnonymous' | translate }}
                                        </div>
                                        <div class="col col-sm primary-1" *ngIf="!project.isAnonymized">
                                            {{ project.organization.name }}
                                        </div>
                                    </div>
                                </div>
                                <!-- Organisation -->
                                <!-- Communautés -->
                                <div class="col-12">
                                    <div
                                        class="row"
                                        *ngIf="project.communities && project.communities.length > 0 && !project.allCommunitiesVisibility"
                                    >
                                        <div class="col-12 col-sm-6 fw-b primary-1">
                                            {{ 'projects.pages.details.communities' | translate }}
                                        </div>
                                        <div class="col-12 col-sm">
                                            <span *ngFor="let community of project.communities" class="badge badge-primary mr-1">{{
                                                community.displayName
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- /Communautés -->
                                <!-- Visible par tous -->
                                <div class="col-12">
                                    <div class="row" *ngIf="project.allCommunitiesVisibility">
                                        <div class="col-6 col-sm-4 fw-b primary-1">
                                            {{ 'projects.pages.details.communities' | translate }}
                                        </div>
                                        <div class="col-6 col-sm">
                                            <span class="badge badge-primary mr-1">
                                                {{ 'shared.projectScopeSelection.visible' | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- /Visible par tous -->
                            </div>
                        </div>

                        <!-- Participants-->
                        <div class="col-12 col-md-4 col-sm-6 block-participants">
                            <div class="row" *ngIf="!project.isAnonymized">
                                <div class="col-12 fw-b primary-1">
                                    {{ 'projects.pages.details.members' | translate }}
                                    <button
                                        *ngIf="isOwner && project.status !== 'finished' && project.pendingAttendees.length > 0"
                                        type="button"
                                        (click)="showWaitingAttendeesDialog()"
                                        icon="pi pi-info-circle"
                                        label="{{ 'projects.pages.details.members' | translate }}"
                                        class="btn btn-primary btn-sm btn-notif"
                                    >
                                        {{ 'projects.pages.details.requests' | translate }}
                                        <div class="bullet-notif">
                                            {{ project.pendingAttendees.length }}
                                        </div>
                                    </button>
                                </div>
                                <div class="col-12">
                                    <ul class="row list-participants">
                                        <li *ngFor="let profile of project.attendees | slice : 0 : 5; let i = index">
                                            <app-user-avatar
                                                *ngIf="profile.active"
                                                [ngClass]="{
                                                    surrounded: i == 0
                                                }"
                                                [firstName]="profile.firstName"
                                                [lastName]="profile.lastName"
                                                [picture]="profile.profilePicture"
                                                [routerLink]="['/directory/profile', profile.id]"
                                                data-dismiss="modal"
                                            ></app-user-avatar>
                                            <app-user-avatar
                                                *ngIf="!profile.active"
                                                [ngClass]="{
                                                    surrounded: i == 0
                                                }"
                                                [firstName]="profile.firstName"
                                                [lastName]="profile.lastName"
                                                [picture]="profile.profilePicture"
                                                data-dismiss="modal"
                                            ></app-user-avatar>
                                        </li>

                                        <li class="more" (click)="showAttendeesDialog()">
                                            <span>+{{ project.attendees.length > 5 ? project.attendees.length - 5 : '' }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row" *ngIf="project.isAnonymized">
                                <div class="col-12 fw-b primary-1">
                                    {{ 'projects.pages.details.members' | translate }}
                                </div>
                                <div class="col-12">{{ 'projects.pages.details.isAnonymous' | translate }}</div>
                            </div>
                        </div>

                        <div class="col-12 col-md-4 col-sm-6 mt-2">
                            <div *ngIf="project?.status !== 'finished'">
                                <div class="fw-b primary-1">
                                    <span *ngIf="!isConfirmedAttendee && !isPendingAttendee">
                                        {{ 'projects.pages.details.joinProject.newMemberLabel' | translate }}
                                    </span>
                                    <span *ngIf="isConfirmedAttendee">
                                        {{ 'projects.pages.details.joinProject.existingMemberLabel' | translate }}
                                    </span>
                                    <span *ngIf="isPendingAttendee">
                                        {{ 'projects.pages.details.joinProject.pendingMemberLabel' | translate }}
                                    </span>
                                </div>
                                <div *ngIf="project.collaborationPlatformUrl && canViewCollaborativePlatform">
                                    <large-button
                                        *ngIf="project.collaborationPlatformUrl"
                                        [label]="'projects.pages.details.joinCollab' | translate"
                                        [icon]="'pi pi-directions'"
                                        (click)="hookOpenCollaborationPlatform()"
                                    ></large-button>
                                    <div *ngIf="!project.collaborationPlatformUrl">
                                        <div class="fw-b primary-1">
                                            {{ 'projects.pages.details.collaborationPlatform.title' | translate }}
                                        </div>
                                        <span *ngIf="!isCollaborationPlatformAsyncCreation">{{
                                            'projects.pages.details.collaborationPlatform.none' | translate
                                        }}</span>
                                        <span *ngIf="isCollaborationPlatformAsyncCreation">{{
                                            'projects.pages.details.collaborationPlatform.inProgress' | translate
                                        }}</span>
                                    </div>
                                </div>
                                <div *ngIf="isOwner && attendeesExceptOwner?.length > 0">
                                    <large-button
                                        [label]="'projects.pages.details.contactTeam' | translate"
                                        [outlined]="true"
                                        (click)="contactMyTeamClick()"
                                    >
                                    </large-button>
                                </div>
                                <div *ngIf="!isOwner">
                                    <large-button
                                        *ngIf="isConfirmedAttendee"
                                        [label]="'projects.modals.leave.button' | translate"
                                        [outlined]="true"
                                        (click)="openLeaveProjectDialog()"
                                    ></large-button>
                                    <large-button
                                        *ngIf="!isConfirmedAttendee && !isPendingAttendee"
                                        [label]="'projects.modals.join.button' | translate"
                                        [outlined]="true"
                                        (click)="openJoinProjectDialog()"
                                    ></large-button>
                                    <large-button
                                        *ngIf="isPendingAttendee"
                                        [label]="'projects.modals.cancelJoin.button' | translate"
                                        [outlined]="true"
                                        (click)="openCancelJoinProjectDialog()"
                                    ></large-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- DESCRIPTION -->
            <div class="col-12 mt-2">
                <div class="card box-shadow">
                    <div class="card-body">
                        <h2 class="h5 primary-1">
                            {{ 'projects.pages.details.description' | translate }}
                        </h2>
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="fw-b project-details-label primary-1">
                                    {{ 'projects.pages.details.context' | translate }}
                                </div>
                                <quill-view [content]="project.context"></quill-view>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="fw-b project-details-label primary-1">
                                    {{ 'projects.pages.details.goals' | translate }}
                                </div>
                                <ul class="list-group">
                                    <li *ngFor="let goal of project.goals" class="list-group-item">
                                        {{ goal }}
                                    </li>
                                </ul>
                            </div>

                            <div class="col-12 mt-4">
                                <div class="fw-b project-details-label primary-1">
                                    {{ 'projects.pages.details.expectedContributions' | translate }}
                                </div>
                                <quill-view [content]="project.contributions"></quill-view>
                            </div>

                            <div class="col-12 mt-4">
                                <div class="fw-b project-details-label primary-1">
                                    {{ 'projects.pages.details.detailedDescription' | translate }}
                                </div>
                                <quill-view [content]="project.description"></quill-view>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CENTRES D'INTERETS + COMPETENCES -->
            <div class="col-12 mt-2" [ngClass]="{ 'mb-3 mb-sm-0': !modifierListReady }">
                <project-skills-interest [project]="project"></project-skills-interest>
            </div>

            <!-- Historique des modifications -->
            <div class="col-12 mt-2 mb-3 mb-sm-0" *ngIf="modifierListReady">
                <div class="card box-shadow">
                    <div class="card-body">
                        <h2 class="h5 primary-1">{{ 'projects.pages.details.history.title' | translate }}</h2>
                        <div class="row">
                            <div class="col-12 col-sm-12">
                                <p>{{ 'projects.pages.details.history.subtitle' | translate }}</p>
                                <ul class="">
                                    <li *ngFor="let update of project.updates" class="">
                                        {{
                                            'projects.pages.details.history.modified'
                                                | translate
                                                    : {
                                                          date: update.date,
                                                          author: getModifierFullNameById(update.modifierId)
                                                      }
                                        }}
                                        <p>{{ update.message }}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Dialog join project -->
        <dialog-join-project
            [visible]="joinProjectDialog"
            [project]="project"
            (acted)="userJoinedProject()"
            (visibleChange)="closeJoinProjectDialog()"
        >
        </dialog-join-project>

        <!-- Dialog cancel join project -->
        <dialog-cancel-join-project
            [visible]="cancelJoinProjectDialog"
            [project]="project"
            (acted)="userCancelJoinedProject()"
            (visibleChange)="closeCancelJoinProjectDialog()"
        >
        </dialog-cancel-join-project>

        <!-- Dialog delete project -->
        <dialog-delete-project [visible]="deleteProjectDialog" [project]="project" (visibleChange)="closeDeleteProjectDialog()">
        </dialog-delete-project>

        <!-- Dialog leave project -->
        <dialog-leave-project
            [visible]="leaveProjectDialog"
            [project]="project"
            (acted)="userLeftProject()"
            (visibleChange)="closeLeaveProjectDialog()"
        >
        </dialog-leave-project>

        <!-- Modal participants -->
        <dialog-list-attendees
            [project]="project"
            [visible]="attendeesDialog"
            [isMemberOrOwnerOfProject]="isMemberOrOwnerOfProject()"
            (visibleChange)="closeAttendeesModal()"
        ></dialog-list-attendees>

        <!-- Modal participants en attente -->
        <dialog-list-pending-attendees
            [project]="project"
            [visible]="waitingAttendeesDialog"
            [isMemberOrOwnerOfProject]="isMemberOrOwnerOfProject()"
            (visibleChange)="closeWaitingAttendeesDialog()"
        ></dialog-list-pending-attendees>

        <!-- Modal cloturer -->
        <dialog-close-project [project]="project" [visible]="closeProjectDialog" (visibleChange)="closeCloseProjectModal()"> </dialog-close-project>
    </div>
</div>
